import { Component, Inject, Injector } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { LoadingDialogComponent } from '../loading-dialog/loading-dialog.component';
import { ApiService as ApiPhoto } from 'src/app/services/photo/api.service';

@Component({
  selector: 'app-progressbar-dialog',
  templateUrl: './progressbar-dialog.component.html',
  styleUrls: ['./progressbar-dialog.component.css']
})
export class ProgressbarDialogComponent {
  data: any = MAT_DIALOG_DATA;
  dataMobile: any = MAT_BOTTOM_SHEET_DATA;
  progress: number = 0;
  destroyed = new Subject<void>();
  appServiceScreenDesktop!: boolean;
  appServiceScreenMobile!: boolean;
  appServiceScreenMobileSmall!: boolean;

  constructor(@Inject(Injector)public injector: Injector, private dialogRef: MatDialogRef<LoadingDialogComponent>, private apiPhoto: ApiPhoto, public appService: AppService) {
    this.appService.breakpointDesktop$.pipe(takeUntil(this.destroyed)).subscribe(result => {
      this.appServiceScreenDesktop = result
    })

    this.appService.breakpointMobile$.pipe(takeUntil(this.destroyed)).subscribe(result => {
      this.appServiceScreenMobile = result
    })

    this.appService.breakpointMobileSmall$.pipe(takeUntil(this.destroyed)).subscribe(result => {
      this.appServiceScreenMobileSmall = result
    })
    this.apiPhoto.getIsProgress().subscribe(appIsProgress => this.progress = appIsProgress)
  }
}
